<template>
  <div class="ca-pesquisa-resultados">
    <div class="ca-pesquisa-resultados__hero pt-size-8 pb-size-7">
      <div class="ca-bullet-container">
        <div class="ca-pesquisa-resultados__header mb-size-6">
          <h1 class="ca-pesquisa-resultados__title">Resultados da Pesquisa</h1>
          <p class="ca-pesquisa-resultados__count">
            {{ totalCount }} resultados para '<strong>{{ searchQuery }}</strong
            >'
          </p>
        </div>

        <CaPesquisaBar
          v-model="searchQuery"
          class="ca-pesquisa-resultados__bar"
          @submit="submitSearch"
          @clear="clearSearch"
        />
      </div>
    </div>

    <div class="ca-pesquisa-resultados__main">
      <div class="ca-bullet-container ca-pesquisa-resultados__main-content">
        <CaPesquisaFiltros
          v-if="!isEmpty"
          v-model="activeSegment"
          :tabs="tabs"
          class="ca-pesquisa-resultados__filtros"
        />

        <CaPesquisaVazio
          v-if="isEmpty"
          :query="searchQuery"
          class="ca-pesquisa-resultados__lista"
        />
        <CaPesquisaLista
          v-else
          :results="paginatedResults"
          :loading="loading"
          class="ca-pesquisa-resultados__lista"
        />

        <CaPesquisaMaisPesquisados
          title="Mais pesquisados"
          :items="maisPesquisados"
          class="ca-pesquisa-resultados__sidebar"
        />

        <div v-if="!isEmpty" class="ca-pesquisa-resultados__paginacao">
          <CaPesquisaPaginacao
            :current-page="currentPage"
            :total-pages="totalPages"
            @change="goToPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const mockTabs = [
  { label: "Todos", count: 1091, segment: "todos" },
  { label: "Particulares", count: 42, segment: "particulares" },
  { label: "Empresas", count: 32, segment: "empresas" },
  { label: "Institucional", count: 1015, segment: "institucional" },
  { label: "Sustentabilidade", count: 1, segment: "sustentabilidade" },
  { label: "Associados", count: 1, segment: "associados" },
];

const mockMaisPesquisados = [
  { title: "Ver cartões de crédito", url: "#" },
  { title: "Atualizar dados pessoais", url: "#" },
  { title: "Abrir conta online", url: "#" },
  { title: "Pedir crédito pessoal online", url: "#" },
  { title: "Abrir conta empresa", url: "#" },
  { title: "Atualizar dados empresas", url: "#" },
];

const isDev = import.meta.env.DEV;

const mockResults = [
  {
    title:
      "Prevenir e Regularização de situações de incumprimento de contrato de crédito",
    subtitle: "Dificuldades Financeiras",
    category: "AJUDA",
    categoryIcon: "ajuda",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Investir",
    subtitle: "Para Mim",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Simulador Crédito Pessoal",
    subtitle: "O melhor caminho para os seus sonhos.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Abra a sua conta no crédito agrícola. Nós tratamos de tudo.",
    subtitle: "Dia-a-dia",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Crédito Agrícola - Open Banking API",
    subtitle: "Serviços",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "empresas",
  },
  {
    title: "Crédito Habitação - CA Casa Energia Eficiente",
    subtitle: "A solução mais sustentável.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Simulador de Crédito Habitação",
    subtitle: "Calcule a sua prestação mensal.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "particulares",
  },
  {
    title: "Relatório de Sustentabilidade 2023",
    subtitle: "Compromisso com o futuro.",
    category: "SERVIÇOS",
    categoryIcon: "servicos",
    url: "#",
    segment: "sustentabilidade",
  },
  {
    title: "Linha de Apoio ao Investimento Empresarial",
    subtitle: "Soluções de financiamento para empresas.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "empresas",
  },
  {
    title: "Crédito ao Setor Agrícola",
    subtitle: "Financiamento adaptado às necessidades do agricultor.",
    category: "PRODUTOS E SERVIÇOS",
    categoryIcon: "produtos",
    url: "#",
    segment: "empresas",
  },
  {
    title: "Estatutos e Regulamentos",
    subtitle: "Documentação institucional do Crédito Agrícola.",
    category: "SERVIÇOS",
    categoryIcon: "servicos",
    url: "#",
    segment: "institucional",
  },
  {
    title: "Associados do Crédito Agrícola",
    subtitle: "Informação para associados.",
    category: "SERVIÇOS",
    categoryIcon: "servicos",
    url: "#",
    segment: "associados",
  },
];
</script>

<script setup>
import { ref, computed, watch } from "vue";
import CaPesquisaBar from "./CaPesquisaBar.vue";
import CaPesquisaFiltros from "./CaPesquisaFiltros.vue";
import CaPesquisaLista from "./CaPesquisaLista.vue";
import CaPesquisaVazio from "./CaPesquisaVazio.vue";
import CaPesquisaMaisPesquisados from "./CaPesquisaMaisPesquisados.vue";
import CaPesquisaPaginacao from "./CaPesquisaPaginacao.vue";

const PAGE_SIZE = 10;

const props = defineProps({
  phrase: { type: String, default: "" },
  segment: { type: String, default: "todos" },
  tabs: { type: Array, default: () => (isDev ? mockTabs : []) },
  results: { type: Array, default: () => (isDev ? mockResults : []) },
  maisPesquisados: {
    type: Array,
    default: () => (isDev ? mockMaisPesquisados : []),
  },
});

const activeSegment = ref(props.segment);
const searchQuery = ref(props.phrase);
const results = ref(props.results);
const currentPage = ref(1);
const tabs = computed(() =>
  props.tabs.filter((t) => t.segment === "todos" || t.count > 0),
);
const loading = ref(false);

const filteredResults = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  let list = results.value;

  if (q) {
    list = list.filter(
      (r) =>
        r.title.toLowerCase().includes(q) ||
        r.subtitle?.toLowerCase().includes(q),
    );
  }

  if (activeSegment.value !== "todos") {
    list = list.filter((r) => r.segment === activeSegment.value);
  }

  return list;
});

const totalPages = computed(() =>
  Math.max(1, Math.ceil(filteredResults.value.length / PAGE_SIZE)),
);

const paginatedResults = computed(() => {
  const start = (currentPage.value - 1) * PAGE_SIZE;
  return filteredResults.value.slice(start, start + PAGE_SIZE);
});

const totalCount = computed(() => filteredResults.value.length);
const isEmpty = computed(
  () => !loading.value && filteredResults.value.length === 0,
);

watch([activeSegment, searchQuery], () => {
  currentPage.value = 1;
});

function goToPage(page) {
  currentPage.value = page;
  window.scrollTo({ top: 0, behavior: "smooth" });
}

function submitSearch() {
  if (!searchQuery.value.trim()) return;
  window.location.href = `/pesquisa?phrase=${encodeURIComponent(searchQuery.value)}`;
}

function clearSearch() {
  searchQuery.value = "";
}
</script>

<style scoped lang="scss">
.ca-pesquisa-resultados {
  background: transparent;

  &__title {
    font-size: var(--font-size-4xl);
    font-weight: var(--font-weight-bold);
    color: var(--ca-color-text-body);
    line-height: var(--line-height-3xl);
    letter-spacing: var(--letter-spacing-lg);
    margin: 0 0 var(--size-2) 0;

    @include ca-bp("sm") {
      font-size: var(--font-size-6xl);
      line-height: var(--line-height-7xl);
      letter-spacing: var(--letter-spacing-xl);
    }
  }

  &__count {
    font-size: var(--font-size-md);
    color: var(--ca-color-text-body-variant);
    line-height: var(--line-height-md);
    letter-spacing: var(--letter-spacing-md);
    margin: 0;

    strong {
      font-weight: var(--font-weight-semibold);
      color: var(--ca-color-text-body);
    }
  }

  &__bar {
    max-width: 844px;
  }

  &__main {
    background: var(--ca-color-text-inverted);
    border-radius: var(--radius-xl) var(--radius-xl) 0 0;
    padding-bottom: var(--size-8);
  }

  &__main-content {
    padding-top: var(--size-8);
    display: grid;
    row-gap: var(--size-5);
    grid-template-areas:
      "filtros"
      "lista"
      "paginacao"
      "sidebar";

    @include ca-bp("sm") {
      grid-template-areas:
        "filtros   filtros"
        "lista     sidebar"
        "paginacao paginacao";
      grid-template-columns: 70% 25%;
      justify-content: space-between;
      row-gap: var(--size-11);
    }
  }

  &__filtros {
    grid-area: filtros;
  }
  &__lista {
    grid-area: lista;
  }

  &__sidebar {
    grid-area: sidebar;
    order: 4;

    @include ca-bp("sm") {
      order: unset;
    }
  }

  &__paginacao {
    grid-area: paginacao;
    display: flex;
    justify-content: center;
    order: 3;

    @include ca-bp("sm") {
      order: unset;
    }
  }
}
</style>
